import { QueryParamsProps } from "../declarations/commonServices";

export const GetQueryVariables = ({
  limit,
  offset,
  assigned,
  buyerName,
  buyerPhone,
  fuel,
  listingType,
  make,
  maxMileage,
  maxPrice,
  maxYear,
  minPrice,
  minYear,
  minMileage,
  populate,
  search,
  sort,
  status,
  transmission,
  usageType,
  statusChangedBy,
}: QueryParamsProps): QueryParamsProps => {
  let queryParams: QueryParamsProps = {};

  if (limit !== undefined) {
    queryParams.limit = limit;
  }

  if (offset !== undefined) {
    queryParams.offset = offset;
  }

  if (populate) {
    queryParams.populate = populate;
  }

  if (search) {
    queryParams.search = search;
  }

  if (sort) {
    queryParams.sort = sort;
  }

  if (status) {
    queryParams.status = status;
  }

  if (make) {
    queryParams.make = make;
  }

  if (minYear) {
    queryParams.minYear = minYear;
  }

  if (maxYear) {
    queryParams.maxYear = maxYear;
  }

  if (minPrice) {
    queryParams.minPrice = minPrice;
  }

  if (maxPrice) {
    queryParams.maxPrice = maxPrice;
  }

  if (minMileage) {
    queryParams.minMileage = minMileage;
  }

  if (maxMileage) {
    queryParams.maxMileage = maxMileage;
  }

  if (transmission) {
    queryParams.transmission = transmission;
  }

  if (fuel) {
    queryParams.fuel = fuel;
  }

  if (usageType) {
    queryParams.usageType = usageType;
  }

  if (listingType) {
    queryParams.listingType = listingType;
  }

  if (assigned) {
    queryParams.assigned = assigned;
  }

  if (buyerName) {
    queryParams.buyerName = buyerName;
  }

  if (buyerPhone) {
    queryParams.buyerPhone = buyerPhone;
  }

  if (buyerPhone) {
    queryParams.buyerPhone = buyerPhone;
  }

  if (statusChangedBy) {
    queryParams.statusChangedBy = statusChangedBy;
  }

  return queryParams;
};
